var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"App",attrs:{"id":"app"}},[_c('Layout'),_c('Spinner',{staticClass:"spinner",attrs:{"full":"","text":"cargando...","visible":_vm.isVisible}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }